//@flow

const ADD_DIR_SVC_MAPPINGS = '/admin/dirSvc/ADD_DIR_SVC_MAPPINGS';
const ADD_DIR_SVC_MAPPINGS_FAIL = '/admin/dirSvc/ADD_DIR_SVC_MAPPINGS_FAIL';
const ADD_DIR_SVC_MAPPINGS_SUCCESS =
  '/admin/dirSvc/ADD_DIR_SVC_MAPPINGS_SUCCESS';
const GET_DIR_SVC_MAPPINGS = '/admin/dirSvc/GET_DIR_SVC_MAPPINGS';
const GET_DIR_SVC_MAPPINGS_FAIL = '/admin/dirSvc/GET_DIR_SVC_MAPPINGS_FAIL';
const GET_DIR_SVC_MAPPINGS_SUCCESS =
  '/admin/dirSvc/GET_DIR_SVC_MAPPINGS_SUCCESS';
const QUERY_DIR_SVC = '/admin/dirSvc/QUERY_DIR_SVC';
const QUERY_DIR_SVC_FAIL = 'admin/dirSvc/QUERY_DIR_SVC_FAIL';
const QUERY_DIR_SVC_SUCCESS = 'admin/dirSvc/QUERY_DIR_SVC_SUCCESS';
const RESET_STATE = 'admin/dirSvc/RESET_STATE';
const SET_QUERY_PENDING = 'admin/dirSvc/SET_QUERY_PENDING';
const SET_DESTINATION = 'admin/dirSvc/SET_DESTINATION';
const SET_DIR_SVC_MAPPING = 'admin/dirSvc/SET_DIR_SVC_MAPPING';
const SET_QUERY_TYPE = 'admin/dirSvc/SET_QUERY_TYPE';
const SET_SELECTED_NODE = 'admin/dirSvc/SET_SELECTED_NODE';
const SYNC_MAPPINGS = 'admin/dirSvc/SYNC_MAPPINGS';
const SYNC_MAPPINGS_SUCCESS = 'admin/dirSvc/SYNC_MAPPINGS_SUCCESS';
const SYNC_MAPPINGS_FAIL = 'admin/dirSvc/SYNC_MAPPINGS_FAIL';
const UPDATE_DIR_SVC_MAPPING = 'admin/dirSvc/UPDATE_DIR_SVC_MAPPING';
const UPDATE_DIR_SVC_MAPPING_FAIL = 'admin/dirSvc/UPDATE_DIR_SVC_MAPPING_FAIL';
const UPDATE_DIR_SVC_MAPPING_SUCCESS =
  'admin/dirSvc/UPDATE_DIR_SVC_MAPPING_SUCCESS';

export {
  ADD_DIR_SVC_MAPPINGS,
  ADD_DIR_SVC_MAPPINGS_FAIL,
  ADD_DIR_SVC_MAPPINGS_SUCCESS,
  GET_DIR_SVC_MAPPINGS,
  GET_DIR_SVC_MAPPINGS_FAIL,
  GET_DIR_SVC_MAPPINGS_SUCCESS,
  QUERY_DIR_SVC,
  QUERY_DIR_SVC_FAIL,
  QUERY_DIR_SVC_SUCCESS,
  RESET_STATE,
  SET_DESTINATION,
  SET_DIR_SVC_MAPPING,
  SET_QUERY_PENDING,
  SET_QUERY_TYPE,
  SET_SELECTED_NODE,
  SYNC_MAPPINGS,
  SYNC_MAPPINGS_FAIL,
  SYNC_MAPPINGS_SUCCESS,
  UPDATE_DIR_SVC_MAPPING,
  UPDATE_DIR_SVC_MAPPING_FAIL,
  UPDATE_DIR_SVC_MAPPING_SUCCESS,
};

export type DirSvcNodeAttributes = {
  name?: string,
  objectClass?: string,
};

export type DirSvcNode = {
  attributes: DirSvcNodeAttributes,
  children?: DirSvcNode[],
  dn: string,
  id: string,
};

export type DirSvcMappingEntry = {
  sourceDN: string,
  sourceType: number,
  roleOverrideGuid: string,
  mappingOrder: string,
  unsaved?: boolean,
};

export type DirSvcMapping = {
  uuid: string,
  identityServiceUuid: string,
  targetGroupGuid: string,
  entries: DirSvcMappingEntry[],
  unsaved?: boolean,
};

export type DirSvcState = {
  destination: string,
  mappings: DirSvcMapping[],
  queryIsPending: boolean,
  queryResults: DirSvcNode[],
  queryType: Object,
  selectedNode?: DirSvcNode,
};

type getDirSvcMappingsAction = {|
  type: '/admin/dirSvc/GET_DIR_SVC_MAPPINGS',
|};

type getDirSvcMappingsFailAction = {|
  type: '/admin/dirSvc/GET_DIR_SVC_MAPPINGS_FAIL',
|};

type getDirSvcMappingsSuccessAction = {|
  type: '/admin/dirSvc/GET_DIR_SVC_MAPPINGS_SUCCESS',
|};

type queryDirSvcAction = {|
  type: '/admin/dirSvc/QUERY_DIR_SVC',
|};

type queryDirSvcFailAction = {|
  type: '/admin/dirSvc/QUERY_DIR_SVC_FAIL',
|};

type queryDirSvcSuccessAction = {|
  type: '/admin/dirSvc/QUERY_DIR_SVC_SUCCESS',
  payload: Object,
|};

type setQueryPendingAction = {|
  type: 'admin/dirSvc/SET_QUERY_PENDING',
  payload: boolean,
|};

type setDestinationAction = {|
  type: 'admin/dirSvc/SET_DESTINATION',
  payload: string,
|};

type setQueryTypeAction = {|
  type: 'admin/dirSvc/SET_QUERY_TYPE',
  payload: string,
|};

type setSelectedNodeAction = {|
  type: 'admin/dirSvc/SET_SELECTED_NODE',
  payload: DirSvcNode,
|};

type syncMappingsAction = {|
  type: 'admin/dirSvc/SYNC_DIR_SVC',
|};

type resetState = {|
  type: 'admin/dirSvc/RESET_STATE',
|};

export type Action =
  | getDirSvcMappingsAction
  | getDirSvcMappingsFailAction
  | getDirSvcMappingsSuccessAction
  | queryDirSvcAction
  | queryDirSvcFailAction
  | queryDirSvcSuccessAction
  | resetState
  | setDestinationAction
  | setQueryPendingAction
  | setQueryTypeAction
  | setSelectedNodeAction
  | syncMappingsAction;



// WEBPACK FOOTER //
// ./src/state/types/dirSvcTypes.js